import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PhanCaTrucService from "services/PhanCaTrucService";
import Utils from "utils";

export const SearchPhanCaTrucApi = createAsyncThunk(
  "phanCaTruc/SearchPhanCaTrucApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.search(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhanCaTrucByIdApi = createAsyncThunk(
  "phanCaTruc/GetPhanCaTrucByIdIdApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.detail(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpsertPhanCaTrucApi = createAsyncThunk(
  "phanCaTruc/UpsertPhanCaTrucApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.upsert(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpdateHideColumnTablePhanCaTruc = createAsyncThunk(
  "phanCaTruc/UpdateHideColumnTablePhanCaTruc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.hideColumn(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertPhanCaTrucChiTiet = createAsyncThunk(
  "phanCaTruc/UpSertPhanCaTrucChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.upSertPhanCaTrucChiTiet(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchPhanCaTrucThietLapViTriApi = createAsyncThunk(
  "phanCaTruc/SearchPhanCaTrucThietLapViTriApi",
  async (branchId, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.getAllThietLapViTri(branchId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhanCaTrucThietLapViTriByIdApi = createAsyncThunk(
  "phanCaTruc/GetPhanCaTrucThietLapViTriByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.getThietLapViTriById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpsertPhanCaTrucThietLapViTriApi = createAsyncThunk(
  "phanCaTruc/UpsertPhanCaTrucThietLapViTriApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.upsertThietLapViTri(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhanCaTrucHeaderTableByBranchId = createAsyncThunk(
  "phanCaTruc/GetPhanCaTrucHeaderTableByBranchId",
  async (branchId, { rejectWithValue }) => {
    try {
      const response =
        await PhanCaTrucService.getPhanCaTrucHeaderTableByBranchId(branchId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchPhieuDoiLichApi = createAsyncThunk(
  "phanCaTruc/SearchPhieuDoiLichApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.searchPhieuDoiLich(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhieuDoiLichByIdApi = createAsyncThunk(
  "phanCaTruc/GetPhieuDoiLichByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.getPhieuDoiLich(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetDanhSachTongHopLichLamViecNhanVien = createAsyncThunk(
  "phanCaTruc/GetDanhSachTongHopLichLamViecNhanVien",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.getDanhSachTongHop(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhieuDoiLichByNgayTrucApi = createAsyncThunk(
  "phanCaTruc/GetPhieuDoiLichByNgayTrucApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response =
        await PhanCaTrucService.getPhieuDoiLichByNgayTruc(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertPhieuDoiLichApi = createAsyncThunk(
  "phanCaTruc/UpSertPhieuDoiLichApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.upSertPhieuDoiLich(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const PhanCaTrucExportExcel = createAsyncThunk(
  "phanCaTruc/PhanCaTrucExportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await PhanCaTrucService.export(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const CopyPhanCaTrucApi = createAsyncThunk(
  "phanCaTruc/CopyPhanCaTrucApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.copy(payload);

      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchPhieuDoiLichNghiApi = createAsyncThunk(
  "phanCaTruc/SearchPhieuDoiLichNghiApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.searchPhieuDoiLichNghi(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhieuDoiLichNghiByIdApi = createAsyncThunk(
  "phanCaTruc/GetPhieuDoiLichNghiByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PhanCaTrucService.getPhieuDoiLichNghi(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertPhieuDoiLichNghiApi = createAsyncThunk(
  "phanCaTruc/UpSertPhieuDoiLichNghiApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.upSertPhieuDoiLichNghi(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchLichLamViec = createAsyncThunk(
  "phanCaTruc/searchLichLamViec",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.searchLichLamViec(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ExportLichLamViec = createAsyncThunk(
  "phanCaTruc/exportLichLamViec",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await PhanCaTrucService.exportLichLamViec(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  detail: {},
  headerColumns: [],
  lichTrucs: [],
  lichNghis: [],
  tongHop: [],
  listLichLamViec: [],
};

export const PhanCaTrucSlice = createSlice({
  name: "phanCaTruc",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setPhanCaTrucChiTiet: (state, action) => {
      state.lichTrucs = action.payload;
    },
    setFomatPhanCaTrucChiTiet: (state) => {
      state.detail = {};
      state.lichTrucs = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SearchPhanCaTrucApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchPhanCaTrucApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchPhanCaTrucApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPhanCaTrucByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPhanCaTrucByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
        state.lichTrucs = action.payload.lichTrucs;
        state.lichNghis = action.payload.lichNghis;
      })
      .addCase(GetPhanCaTrucByIdApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpsertPhanCaTrucApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpsertPhanCaTrucApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpsertPhanCaTrucApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhanCaTrucChiTiet.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertPhanCaTrucChiTiet.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhanCaTrucChiTiet.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchPhanCaTrucThietLapViTriApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchPhanCaTrucThietLapViTriApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchPhanCaTrucThietLapViTriApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPhanCaTrucThietLapViTriByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPhanCaTrucThietLapViTriByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      })
      .addCase(GetPhanCaTrucThietLapViTriByIdApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpsertPhanCaTrucThietLapViTriApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpsertPhanCaTrucThietLapViTriApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpsertPhanCaTrucThietLapViTriApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPhanCaTrucHeaderTableByBranchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        GetPhanCaTrucHeaderTableByBranchId.fulfilled,
        (state, action) => {
          state.loading = false;
          state.headerColumns = action.payload;
        },
      )
      .addCase(GetPhanCaTrucHeaderTableByBranchId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPhieuDoiLichByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPhieuDoiLichByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = {
          ...action.payload,
          ngayTruc: Utils.convertMomentToDate(action.payload.ngayTruc),
          ngayMuonDoiLich: Utils.convertMomentToDate(
            action.payload.ngayMuonDoiLich,
          ),
        };
      })
      .addCase(GetPhieuDoiLichByIdApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhieuDoiLichApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertPhieuDoiLichApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhieuDoiLichApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchPhieuDoiLichApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchPhieuDoiLichApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchPhieuDoiLichApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(PhanCaTrucExportExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(PhanCaTrucExportExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(PhanCaTrucExportExcel.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(CopyPhanCaTrucApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(CopyPhanCaTrucApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(CopyPhanCaTrucApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchPhieuDoiLichNghiApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchPhieuDoiLichNghiApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchPhieuDoiLichNghiApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPhieuDoiLichNghiByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPhieuDoiLichNghiByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = {
          ...action.payload,
          ngayNghi: Utils.convertMomentToDate(action.payload.ngayNghi),
          ngayMuonDoiLich: Utils.convertMomentToDate(
            action.payload.ngayMuonDoiLich,
          ),
        };
      })
      .addCase(GetPhieuDoiLichNghiByIdApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhieuDoiLichNghiApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertPhieuDoiLichNghiApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhieuDoiLichNghiApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(
        GetDanhSachTongHopLichLamViecNhanVien.fulfilled,
        (state, action) => {
          state.tongHop = action.payload;
        })
      .addCase(SearchLichLamViec.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchLichLamViec.fulfilled, (state, action) => {
        state.loading = false;
        state.listLichLamViec = action.payload;
      })
      .addCase(SearchLichLamViec.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setPhanCaTrucChiTiet, setFomatPhanCaTrucChiTiet } =
  PhanCaTrucSlice.actions;

export default PhanCaTrucSlice.reducer;
